module.exports = __webpack_public_path__ + "static/img/Roboto-LightItalic.f8b0d5a.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/roboto-fontface/fonts/roboto/Roboto-LightItalic.svg
// module id = Xr6f
// module chunks = 3